import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { merchantVerifiedRoute } from 'root/routeTree';

import { offeringsDraftMissingRoute } from './OfferingsDraftMissingView';
import { offeringsDraftNewRoute } from './OfferingsDraftNewView';
import { offeringsDraftSummaryRoute } from './OfferingsDraftSummaryView';
import { offeringsDraftUpdatedCostRoute } from './OfferingsDraftUpdatedCostView';
import { offeringsDraftUpdatedInformationRoute } from './OfferingsDraftUpdatedInformationView';
import { offeringsDraftUploadRoute } from './OfferingsDraftUploadView';

export const offeringsDraftsRoute = createRoute({
  getParentRoute: () => merchantVerifiedRoute,
  path: '/vendors/$vendorId/offerings-drafts',
  parseParams: (params) => ({
    vendorId: z.string().parse(params.vendorId),
  }),
});

export const offeringsDraftRoute = createRoute({
  getParentRoute: () => offeringsDraftsRoute,
  path: '$offeringsDraftId',
  parseParams: (params) => ({
    offeringsDraftId: z.string().parse(params.offeringsDraftId),
  }),
});

export const offeringsDraftsRouteTree = offeringsDraftsRoute.addChildren({
  offeringsDraftUploadRoute,
  offeringsDraftRoute: offeringsDraftRoute.addChildren({
    offeringsDraftUpdatedCostRoute,
    offeringsDraftUpdatedInformationRoute,
    offeringsDraftNewRoute,
    offeringsDraftMissingRoute,
    offeringsDraftSummaryRoute,
  }),
});
